import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export interface CrawlSession {
    id: number;
    crawl_id: string;
    status: string;
    start_time: string;
    end_time: string | null;
}

export interface CrawlSessionResponse {
    meta: {
        error: boolean;
        code: number;
        message: string;
    };
    data: CrawlSession;
}

export const getCrawlSession = async (storeId: string) => {
    try {
        const response = await Axios.get(`/crawl_session/${storeId}`);
        return response.data as CrawlSessionResponse;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetCrawlSession = (storeId: string) => {
    const crawlSession = useQuery({
        queryKey: ["get-crawl-session", storeId],
        queryFn: () => getCrawlSession(storeId),
        enabled: !!storeId,
        refetchInterval: (query) => {
            // Only refetch if status is in_progress
            if (query.state.data?.data?.status === "in_progress") {
                return 5000; // Refetch every 5 seconds while in progress
            }
            return false; // Don't refetch otherwise
        },
    });

    return crawlSession;
};